// @flow

import React, { Component, Fragment } from 'react';
import { getRencontresDateFormat } from 'utils/rencontreUtils';
import type { DerniereRencontreType } from 'types/Rencontre';
import { shouldUsePlaceholder } from 'utils/assetsUtils';

type Props = {
  dernieres_rencontres: Array<DerniereRencontreType>,
  equipeNom: string,
}

export default class LastRencontresSection extends Component<Props> {

  doesLocalTeamWon = (rencontre: DerniereRencontreType, francePlaysAtHome: boolean) => {
    const { france_score, adversaire_score } = rencontre;
    const className = 'ft-700';
    if (francePlaysAtHome && france_score > adversaire_score ) {
      return className;
    } else if (!francePlaysAtHome && adversaire_score > france_score) {
      return className;
    }
    return '';
  }

  doesChallengerTeamWon = (rencontre: DerniereRencontreType, francePlaysAtHome: boolean) => {
    const { france_score, adversaire_score } = rencontre;
    const className = 'ft-700';
    if (francePlaysAtHome && france_score > adversaire_score ) {
      return;
    } else if (!francePlaysAtHome && adversaire_score > france_score) {
      return '';
    } else if (adversaire_score === france_score) {
      return '';
    } else {
      return className;
    }
  }
  
  renderRencontreBloc = (rencontres: Array<DerniereRencontreType>): Array<React$Element<any>> => {
    const { equipeNom } = this.props;
    const date = new Date().toJSON().slice(0, 10);
    const lastRencontres = rencontres.filter((rencontre) => {
      return rencontre.date_rencontre < date;
    });
    return lastRencontres.map((rencontre) => {
      const francePlaysAtHome = rencontre.reception === 1;
      const { 
        adversaire, 
        embleme_adversaire, 
        embleme_france, 
        france_score, 
        adversaire_score, 
        date_rencontre, 
        journee,
        reception,
        competition,
       } = rencontre;
      return (
        <Fragment key={`${equipeNom}-${adversaire}-${date_rencontre.substr(0, 10)}`}>
          <p className="block-competition__head ft-h6 ft-up mb-1">
            {competition !== '' && competition + ' - '}{journee !== '' && 'Journée '+ journee+ ' - '}{getRencontresDateFormat(date_rencontre)}
          </p>
          <a 
            className="match box box--white mb-2" 
            title={`Voir les infos du Match ${francePlaysAtHome ? equipeNom : adversaire} ${francePlaysAtHome ? adversaire : equipeNom}}`}
            href={rencontre.link}
          >
            <div className="match__club">
              <p className={this.doesLocalTeamWon(rencontre, francePlaysAtHome)}>
                {francePlaysAtHome ? equipeNom : adversaire}
                <img 
                  src={shouldUsePlaceholder({ embleme_adversaire, embleme_france, reception }, true)}
                  alt={`Logo ${francePlaysAtHome ? equipeNom : adversaire}`} 
                  width={"24px"} 
                  height={"24px"}
                />
              </p>
            </div>
            <div className="match__info">
              <p className="match__score">
                <span className={this.doesLocalTeamWon(rencontre, francePlaysAtHome)}>{francePlaysAtHome ? france_score : adversaire_score}</span>
                <span className="match__colon">:</span>
                <span className={this.doesChallengerTeamWon(rencontre, francePlaysAtHome)}>{francePlaysAtHome ? adversaire_score : france_score}</span>
              </p>
            </div>
            <div className="match__club">
              <p className={this.doesChallengerTeamWon(rencontre, francePlaysAtHome)}>
                {francePlaysAtHome ? adversaire : equipeNom}
                <img 
                  src={shouldUsePlaceholder({embleme_adversaire, embleme_france, reception }, false)}
                  alt={`Logo ${francePlaysAtHome ? adversaire : equipeNom }`}  
                  width={"24px"} 
                  height={"24px"}
                />
              </p>
            </div>
          </a>
        </Fragment>
      );
    });
  }
  render() {
    const { dernieres_rencontres } = this.props;
    return (
      <div className="col col-lg-8on9">
        <h3 className="mb-3">Dernières Rencontres</h3>
          {this.renderRencontreBloc(dernieres_rencontres)}
      </div>
    );
  }
}
